// extracted by mini-css-extract-plugin
var _1 = "SettingsShared_demoMode__hAogi";
var _2 = "SettingsShared_header__5QfZI";
var _3 = "SettingsShared_headerFlex__flmqQ";
var _4 = "SettingsShared_headerText__9VsFn";
var _5 = "SettingsShared_wrapper__n6TNU";
export { _1 as "demoMode", _2 as "header", _3 as "headerFlex", _4 as "headerText", _5 as "wrapper" }
